import {FilterConfig} from '@src/model/filter';
import {DeviceRow, DisplayStatus} from '@src/dtos/device.dto';
import {useStores} from '@src/components/store';
import {MAX_REGISTERED_DEVICES} from '@src/utils/constants';

const isInviteSent = (d: DeviceRow) =>
    d.displayStatus === DisplayStatus.PENDING ||
    d.displayStatus === DisplayStatus.SENT;

const isProtected = (d: DeviceRow) => d.displayStatus === DisplayStatus.ACTIVE_VPN_ON;

const isUnprotected = (d: DeviceRow) =>
    d.displayStatus === DisplayStatus.ACTIVE_VPN_OFF ||
    d.displayStatus === DisplayStatus.REVOKED;

export const useDevicesFiltersConfig = (): FilterConfig<DeviceRow> => {
    const {devicesStore} = useStores();
    const radioOptions = [
        {
            count: devicesStore.totalCount,
            option: {label: `Registered ${devicesStore.totalCount}/${MAX_REGISTERED_DEVICES}`, filterFn: () => true},
        },
        {
            count: devicesStore.inviteSentCount,
            option: {label: `Invite sent ${devicesStore.inviteSentCount}`, filterFn: isInviteSent},
        },
        {
            count: devicesStore.protectedCount,
            option: {label: `Protected ${devicesStore.protectedCount}`, filterFn: isProtected},
        },
        {
            count: devicesStore.unprotectedCount,
            option: {label: `Unprotected ${devicesStore.unprotectedCount}`, filterFn: isUnprotected},
        },
    ].filter(({count}) => count > 0)
        .map(({option}) => option);

    return {
        searchBox: {placeholder: 'Search', byFields: ['phoneNumber', 'userName', 'userEmail']},
        radioButtons: {
            defaultSelectionIndex: 0,
            options: radioOptions,
        },
    };
};
